import axios from 'axios';
import moment from 'moment';
import { message, Spin, Tag } from 'antd';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { treeMock } from '../../../Mock/treeMock';
import { DownloadOutlined } from '@ant-design/icons';
import { getMaximoHierarchyData } from '../../ChartCalls';
import localStorage from '../../../../../utils/localStorage';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { API_FILE, IPAddress } from '../../../../../commons/api';
import { treeDataTranslation } from '../../../Utils/Adapter/translationAdapter';


const TreeGraph = (props) => {
  const [option, setOption] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [reportName, setReportName] = useState('');
  const abortController = useRef(new window.AbortController());
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);

  const getData = async () => {
    setLoading(true);
    let json = [];
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock) {
      json = treeMock;
    } else {
      if (graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].customHierarchyName) {
        json = await getMaximoHierarchyData(abortController,graphprops[graphprops.graph].customHierarchyName);
      } else {
        message.error("Please select hierarchy from configuration");
      }
      setLoading(false);
    }
    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && !graphprops.enableMock)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      const reportNameData = await getReportNametoDownload(json);
      const optionData = cloneDeep(getOption());
      if (Array.isArray(json)) {
        const series = await treeDataTranslation(json, props.translationCache);
        console.log(series,"seriesisiis");
        
        optionData.series[0].data = series;
        setOption(optionData);
        setReportName(reportNameData && reportNameData.file ? reportNameData.file : '');
        setRefreshDateTime(moment());
      }
    }
  };

  const getReportNametoDownload = async (excelData) => {
    let payload = {
      Consumption: props.graphprops.title,
      Data: excelData || [],
      ...props.graphprops.excelObj,
      Name: props.graphprops.dashboardName,
      PortName: 'MEW_BMecomo',
      ReportType: 'singleHierarchy',
      Summary: [],
      SummaryReportType: 'singleHierarchy',
      SummaryType: 'false',
      WeeklySummary: [],
      SelectedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      GeneratedDate: moment().format('YYYY-MM-DD HH:mm:ss')
    };

    let accessToken = localStorage.get('accessToken');
    let siteId = localStorage.get('currentSite');
    let options = {
      method: 'POST',
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: JSON.stringify(payload)
    };
    try {
      const { data } = await axios(options);
      return data;
    } catch {
      return '';
    }
  };

  const getOption = () => {
    let theme = props?.theme;
    return {
      tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove'
      },
      toolbox: {
        showTitle: false,
        orient: 'vertical',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            name: props.graphprops ? props.graphprops.title : 'name',
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      series: [
        {
          type: 'tree',
          data: [],
          top: '1%',
          left: '10%',
          bottom: '1%',
          right: '30%',
          symbolSize: 7,
          edgeForkPosition: '63%',
          initialTreeDepth: 1,
          label: {
            position: 'top',
            fontSize: 13,
            fontFamily: 'Arial Black',
            verticalAlign: 'middle',
            color: theme?.algorithm ===  "dark" ? "white" :"black"
          },
          leaves: {
            label: {
              position: 'right',
              verticalAlign: 'middle',
              align: 'left'
            }
          },
          lineStyle: {
            width: 1,
            color: 'steelblue'
          },
          expandAndCollapse: true,
          animationDuration: 550,
          animationDurationUpdate: 750
        }
      ]
    };
  };


  useEffect(() => {
    getData();
    const refreshTime = props.graphprops?.refreshTime ? props.graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, props.selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, [props.graphprops.refreshTime]);


  useEffect(() => {
    if (
      props.graphprops !== props.graphprops ||
      props.selectionDate !== props.selectionDate ||
      props.selectionDateLive !== props.selectionDateLive ||
      props.selectionMonth !== props.selectionMonth ||
      props.selectionWeek !== props.selectionWeek ||
      props.DeviceCode !== props.DeviceCode ||
      props.shift !== props.shift ||
      props.selectionDateRange !== props.selectionDateRange ||
      props.dayMonthYear !== props.dayMonthYear ||
      props.dropdownSelection !== props.dropdownSelection ||
      props.dashboardPayload !== props.dashboardPayload ||
      props.AssetCode !== props.AssetCode ||
      props.translationCache !== props.translationCache
    ) {
      getData();
    }
  }, [props]);

  return (
    <span>
      {loading === false ? (
        <Fragment>
          {props.graphprops && props.graphprops.checked === true ? (
            <Tag className="graphTag" color="blue">
              {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
            </Tag>
          ) : null}
          {noDataInDB === true || errorInAPI === true ? (
            noDataInDB === true ? (
              <NoRecordComponent />
            ) : (
              <ErrorComponent />
            )
          ) : (
            <ReactEcharts
              option={option}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: '90%', width: '100%' }}
              className="react_for_echarts"
            />
          )}
          {reportName !== '' ? (
            <a
              href={`${IPAddress.LOCAL}/api/reports/${reportName}`}
              style={{ fontWeight: 'bold' }}
            >
              <DownloadOutlined
                style={{ float: 'right' }}
              />
            </a>
          ) : null}
        </Fragment>
      ) : (
        <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <Spin spinning={loading} tip="Loading..." />
            </div>
      )}
    </span>
  );
};


const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.translationCache,
    theme: state.ThemeReducer,
  };
};

export default connect(mapStateToProps)(TreeGraph);